// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607170334/js/" + chunkId + "." + {"44":"8647870f","225":"bc138acb","481":"6deefba1","486":"e5168931","770":"b651a730"}[chunkId] + ".0.41972696987286784.chunk.js";
};